import { SiGoogle } from "@icons-pack/react-simple-icons"

import { adaptSimpleIcon } from "@/lib/adaptSimpleIcon"

export const GoogleIcon = adaptSimpleIcon(SiGoogle)
